import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { LocalStorage } from 'src/app/enums/local-storage-key.enum';
import { STATUS } from 'src/app/enums/status.enum';
import { SYSTEM } from 'src/app/enums/system.enum';
import { ApiService } from 'src/app/services/api.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-purchase-item-card',
  templateUrl: './purchase-item-card.component.html',
  styleUrls: ['./purchase-item-card.component.css']
})
export class PurchaseItemCardComponent implements OnInit {
  @Input() item: any;
  @Input() index!: number;
  safeResourceUrl!: SafeResourceUrl;
  private url!: string;
  subscription: Subscription = new Subscription();
  lang: string = '';
  user: any;
  id!: string;
  loaded!: number;
  error!: boolean;
  pass_id: string;
  data: any;

  isImageLoading!: boolean;


  constructor(
    private localStorageService: LocalStorageService,
    private apiService: ApiService,
    private sanitizer: DomSanitizer,
  ) {
    this.pass_id = this.item?._id;
    if (this.lang == '') {
      this.lang = this.localStorageService.get(LocalStorage.LANG);
    }
  }

  ngOnInit(): void {
    // this.isImageLoading = true;
    this.loadImage();

  }
  getDatailPassOfPurchase() {
    this.apiService.getDatailPassOfPurchase(this.item?._id).subscribe(res => {
      if (res.status != STATUS.SUCCESS) {
        return;
      };
      this.data = res.data;
    })
  }

  loadImage() {
    this.apiService.getImageOfSystem(this.item?.web_thumbnail)
      .subscribe(
        response => {
          if (response.constructor == Blob) {
            URL.revokeObjectURL(this.url);
            this.url = URL.createObjectURL(response);
            this.safeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
          }
          this.isImageLoading = false;
        },
      );
  }

  getSystem(title: any) {
    let name: string;
    switch (this.lang) {
      case 'kr':
        name = title?.kr;
        break;

      case 'ch':
        name = title?.ch;
        break;

      case 'jp':
        name = title?.jp;
        break;

      default:
        name = title?.en;
        break;
    }
    return name;
  }
}
